import React from "react";
import PropTypes from "prop-types";
import { SidebarUser, Box, Text } from "samba-ui";
import styled from "styled-components";
import Popup from "reactjs-popup";
import ModalItem from "./ModalItem";
import logoutUtil from "../utils/logout";
import { getClientView, setClientView } from "../utils/clientView";

const StyledDiv = styled.div`
  position: fixed;
  bottom: 8px;
  white-space: nowrap;
  width: ${p => (p.collapsed ? "56px" : "240px")};
  transition: width 0.2s;
`;

const User = React.forwardRef((props, ref) => (
  <StyledDiv ref={ref} collapsed={props.collapsed}>
    <SidebarUser {...props} />
  </StyledDiv>
));

const isClientView = getClientView();

const UserComponent = ({ collapsed, user }) => {
  const { imageURL, name, role } = user;

  return (
    <Box>
      <Popup
        position="bottom center"
        on="click"
        arrow={false}
        offsetY={-100}
        contentStyle={{
          width: 225,
          borderRadius: 4,
          padding: 0,
          borderColor: "#CFD6E6"
        }}
        trigger={
          <User
            collapsed={collapsed}
            src={imageURL}
            name={name}
            role={
              role === "superadmin"
                ? "Samba TV Admin"
                : role === "superoperator"
                ? "Samba TV Operator"
                : role === "admin"
                ? "Admin"
                : "Operator"
            }
          />
        }
      >
        <Box>
          {role !== "operator" && (
            <ModalItem>
              <Text
                fontSize={1}
                color="palette.dark.ink"
                opacity={0.7}
                onClick={() => setClientView(isClientView ? "off" : "on")}
              >
                {isClientView ? "Switch to Admin View" : "My dashboards"}
              </Text>
            </ModalItem>
          )}
          <ModalItem>
            <Text
              fontSize={1}
              color="palette.dark.ink"
              opacity={0.7}
              onClick={logoutUtil}
            >
              Click to sign out
            </Text>
          </ModalItem>
        </Box>
      </Popup>
    </Box>
  );
};

UserComponent.propTypes = {
  collapsed: PropTypes.bool,
  user: PropTypes.object
};

export default UserComponent;
